export class GetTableContextRewriteResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "rewrite",
            "baseName": "rewrite",
            "type": "TableContextRewrite",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GetTableContextRewriteResponse.attributeTypeMap;
    }
    constructor() {
    }
}
